import { renderMathInDocument } from 'mathlive';
import Quill from 'quill';
import { BlockEmbed } from 'quill/blots/block';
import { Delta } from 'quill/core';
function getDefaultValue(value = {}) {
    const body = value.body && Array.isArray(value.body.ops)
        ? value.body
        : { ops: [] };
    return {
        title: value.title ?? 'Show more',
        body,
        textColor: value.textColor,
        backgroundColor: value.backgroundColor,
    };
}
function findParentQuill(node) {
    const editorEl = node.closest('.ql-editor');
    const container = editorEl?.parentElement;
    if (!container)
        return null;
    const instance = Quill.find(container);
    return instance instanceof Quill ? instance : null;
}
export default class DiffAccordion extends BlockEmbed {
    static blotName = 'diffAccordion';
    static className = 'ql-diff-accordion';
    static tagName = 'div';
    static headerClassName = 'ql-diff-accordion-header';
    static create(inputValue) {
        const node = super.create(inputValue);
        const value = getDefaultValue(inputValue);
        node.dataset.payload = JSON.stringify({
            title: value.title,
            body: value.body,
            textColor: value.textColor,
            backgroundColor: value.backgroundColor,
        });
        const header = document.createElement('div');
        header.className = DiffAccordion.headerClassName;
        header.textContent = value.title;
        header.addEventListener('click', () => {
            const quill = findParentQuill(node);
            if (!quill)
                return;
            const accordionBlot = Quill.find(node);
            if (!accordionBlot || accordionBlot instanceof Quill)
                return;
            const { body: bodyDelta } = DiffAccordion.value(node);
            const bodyOps = bodyDelta?.ops ?? [];
            if (!bodyOps.length)
                return;
            const index = quill.getIndex(accordionBlot);
            const contents = quill.getContents();
            const newContents = contents
                .slice(0, index)
                .concat(new Delta(bodyOps))
                .concat(contents.slice(index + 1));
            quill.setContents(newContents);
            renderMathInDocument();
        });
        node.appendChild(header);
        return node;
    }
    static value(domNode) {
        try {
            const payload = JSON.parse(domNode.dataset.payload || '{}');
            return getDefaultValue(payload);
        }
        catch {
            return getDefaultValue();
        }
    }
}
